import React, { useState, useEffect } from 'react';
import { Icon } from "@iconify/react";
import { LoadingGIF } from "@/config/config";
import styles from './index.module.scss';

const Modal = ({ type, outLogin, children, cancel, getCapInvite, reEligible, footerBotton }) => {
  console.log('~333333', children, !children);
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return <div className={styles.modal}>
    <div className={styles.content}>
      <div className={styles.cancel}>
        <Icon icon='line-md:close' className={styles.cancelIcon} onClick={(e) => { e.stopPropagation(); cancel(); }} />
      </div>
      {type === 'loading' && <img src={LoadingGIF} className={styles.loadingIcon} />}
      {type === 'success' && <Icon icon='mdi:checkbox-marked-circle-auto-outline' className={styles.successIcon} />}
      {type === 'sample' && <img className='w-[151px] h-[100px]' src={"/static/getSample.png"} alt={""} />}
      {!type && <Icon icon='material-symbols:brightness-alert-rounded' className={styles.tipIcon} />}
      {type !== 'sample' && <div className={styles.text}>
        {children}
      </div>}
      {type === 'sample' && <div className={styles.sampleInfo}>
        <div className={styles.infoTitle}>
          Join our Creator Affiliate Program to get offline samples!
        </div>
        <ul>
          <li className={styles.infoText} style={{ marginTop: '8px' }}>Ready to join our Creator Affiliate Program? After joining, you’ll enjoy our <span className={styles.infoTextDiff}>Highest Commissions</span> on every product (ranging from 12%-30%) , <span className={styles.infoTextDiff}>Offline Samples</span>, <span className={styles.infoTextDiff}>Exclusive Extra View Boost</span>, Personalized <span className={styles.infoTextDiff}>1v1 Support</span>, and TikTok Flash Sales. </li>
          <li className={styles.infoText} >Click the “Get Eligible” button below and we'll send you a Linking Invite and more partner details from our affiliate account <span className={styles.infoTextDiff}>Uango</span> to your TikTok. Simply check the link we sent and <span className={styles.infoTextDiff}></span>accept the request!</li>
        </ul>
        <div className={styles.footerBox}>
          <div className={styles.submit} onClick={getCapInvite}>Obtain Eligibility</div>
          <div className={styles.cancel} onClick={reEligible}>I'm already eligible</div>
        </div>
      </div>}
      {footerBotton && <div className={styles.wrap}>
        <div className={styles.leftBotton} onClick={outLogin}>Yes</div>
        <div className={styles.rightBotton} onClick={(e) => { e.stopPropagation(); cancel(); }}>No</div>
      </div>}
    </div>
  </div >;
};
export default Modal;